import useNamespacedLocalStorage from 'app/hooks/useNamespacedLocalStorage';

export default function useShouldAutoOpen() {
  return useNamespacedLocalStorage<boolean>('tailorAutoOpen');
}
